export const scopeOptions = [
  { value: "doc", label: "Document (doc)" },
  { value: "anno", label: "Annotation (anno)" },
];

export const annotationKeys = [
  { key: "tags", label: "Tags" },
  { key: "subThemes", label: "Sub-Themes" },
  { key: "themes", label: "Themes" },
];

export const DEFAULT_ANNOTATION_COUNTS = {
  tags: 10,
  subThemes: 10,
  themes: 10,
};


